import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Speaking from "./pages/Speaking";
import Book from "./pages/Book";
import MediaKit from "./pages/MediaKit";
import BookRavi from "./pages/BookRavi";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/book" element={<Book />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/book-ravi" element={<BookRavi />} />
            {/* Static HTML redirects */}
            <Route path="/pages/about" element={<Navigate to="/about-ravi.html" replace />} />
            <Route path="/pages/speaker" element={<Navigate to="/speaker-ravi.html" replace />} />
            <Route path="/pages/book" element={<Navigate to="/book-ravi.html" replace />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Analytics />
      </div>
    </HelmetProvider>
  );
}

export default App;
